import MatchEvent from 'interfaces/matchEvent';
import lodash from 'lodash';

export default function (matchEvent1: MatchEvent, matchEvent2: MatchEvent): boolean {
  if (
    lodash.isEqual(
      lodash.omit(matchEvent1, ['timestamp', 'internal', '__proto__', 'person', 'team']),
      lodash.omit(matchEvent2, ['timestamp', 'internal', '__proto__', 'person', 'team']),
    )
  ) {
    return matchEvent1.person?.id === matchEvent2.person?.id && matchEvent1.team?.id === matchEvent2.team?.id;
  } else {
    return false;
  }
}
